export const isWithinImage = (x, y, backgroundImageRef) => {
  if (!backgroundImageRef.current) return false;
  const { drawX, drawY, drawWidth, drawHeight } = backgroundImageRef.current;
  return (
    x >= drawX &&
    x <= drawX + drawWidth &&
    y >= drawY &&
    y <= drawY + drawHeight
  );
};
